module.exports = __webpack_public_path__ + "img/location.bcb18727.svg";